module.exports = __webpack_public_path__ + "static/media/Group 3@2x.1bafe4bb.png";